import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { HeaderAlert } from '@core/models/header-alert.model';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'app-header-alert',
  templateUrl: './header-alert.component.html',
  styleUrls: ['./header-alert.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, SvgIconComponent]
})
export class HeaderAlertComponent implements OnChanges {
  @Input() data: HeaderAlert;


  constructor(private router: Router) { }

  ngOnChanges(): void {
   
  }
}
